// @flow

export function getRelatedInputNameFromError(errorCode: string, country: string): string {
  const userField = getUserField(errorCode);

  if (typeof userField === 'string') {
    return userField;
  }

  if (typeof userField === 'object' && (country in userField)) {
    return userField[country];
  }

  throw new Error(`Can't get related input name for errorCode ${errorCode}`);
}

function getUserField(errorCode: string): string | { br: string } | void {
  switch (errorCode) {
    case 'BP-DR-13':
      return 'customerName';

    case 'BP-DR-15':
    case 'BP-DR-17':
    case 'BP-DR-98':
      return 'customerEmail';

    case 'BP-DR-22':
    case 'BP-DR-23':
      return {
        ar: 'argentineDocument',
        bo: 'bolivianDocument',
        br: 'brazilianDocument',
        cl: 'chileanDocument',
        co: 'colombianDocument',
        ec: 'ecuadorianDocument',
        mx: 'mexicanDocument',
        pe: 'peruvianDocument',
      };

    case 'BP-DR-24':
      return {
        ar: 'argentineZipcode',
        bo: 'bolivianZipcode',
        br: 'brazilianZipcode',
        cl: 'chileanZipcode',
        co: 'colombianZipcode',
        ec: 'ecuadorianZipcode',
        mx: 'mexicanZipcode',
        pe: 'peruvianZipcode',
      };

    case 'BP-DR-25':
      return {
        ar: 'argentineAddress',
        bo: 'bolivianAddress',
        br: 'brazilianAddress',
        cl: 'chileanAddress',
        co: 'colombianAddress',
        ec: 'ecuadorianAddress',
        mx: 'mexicanAddress',
        pe: 'peruvianAddress',
      };

    case 'BP-DR-26':
      return {
        ar: 'argentineStreetNumber',
        bo: 'bolivianStreetNumber',
        br: 'brazilianStreetNumber',
        cl: 'chileanStreetNumber',
        co: 'colombianStreetNumber',
        ec: 'ecuadorianStreetNumber',
        mx: 'mexicanStreetNumber',
        pe: 'peruvianStreetNumber',
      };

    case 'BP-DR-27':
      return {
        ar: 'argentineCity',
        bo: 'bolivianCity',
        br: 'brazilianCity',
        cl: 'chileanCity',
        co: 'colombianCity',
        ec: 'ecuadorianCity',
        mx: 'mexicanCity',
        pe: 'peruvianCity',
      };

    case 'BP-DR-28':
    case 'BP-DR-29':
      return {
        ar: 'argentineState',
        bo: 'bolivianState',
        br: 'brazilianState',
        cl: 'chileanState',
        co: 'colombianState',
        ec: 'ecuadorianState',
        mx: 'mexicanState',
        pe: 'peruvianState',
      };

    case 'BP-DR-31':
    case 'BP-DR-32':
      return {
        ar: 'argentinePhoneNumber',
        bo: 'bolivianPhoneNumber',
        br: 'brazilianPhoneNumber',
        cl: 'chileanPhoneNumber',
        co: 'colombianPhoneNumber',
        ec: 'ecuadorianPhoneNumber',
        mx: 'mexicanPhoneNumber',
        pe: 'peruvianPhoneNumber',
      };

    case 'BP-DR-51':
    case 'BP-DR-95':
      return 'cardHolderName';

    case 'BP-DR-55':
      return 'cardSecurityCode';

    case 'BP-DR-67':
      return 'cardExpiryDate';

    case 'BP-DR-75':
    case 'BP-DR-83':
    case 'BP-DR-97':
    case 'BP-DR-100':
    case 'BP-DR-101':
      return 'cardNumber';
  }
}
